export class Evented {
    constructor() {
        this.events = {}
    }

    on(eventName, callback, once = false) {
        if (typeof callback !== 'function') return
        if (!Object.hasOwn(this.events, eventName)) {
            this.events[eventName] = []
        }
        this.events[eventName].push({
            eventName,
            once,
            callback,
        })
        return callback
    }

    once(eventName, callback) {
        this.on(eventName, callback, true)
    }

    off(eventName, callback) {
        if (Object.hasOwn(this.events, eventName)) {
            if (typeof callback === 'function') {
                this.events[eventName] = this.events[eventName].filter((av) => {
                    if (callback == av.callback) return false
                    return true
                })
            } else {
                delete this.events[eventName]
            }
        }
    }

    async fire(eventName, ...args) {
        let evs = this.events[eventName]
        if (evs) {
            // Create array of promises from all callbacks
            const promises = evs.map(async (elem) => {
                // Call the callback and await if it returns a promise
                const result = elem.callback(...args)
                return await result
            })

            // Wait for all callbacks to complete (won't reject on individual failures)
            const results = await Promise.allSettled(promises)

            // Log any errors but don't throw
            const errors = results
                .filter((result) => result.status === 'rejected')
                .map((result) => result.reason)

            if (errors.length > 0) {
                console.error(
                    `${errors.length} handler(s) failed for '${eventName}':`,
                    errors
                )
            }

            // Clean up 'once' listeners after all have executed
            evs.forEach((elem) => {
                if (elem.once) {
                    this.off(eventName, elem.callback)
                }
            })
        }
    }

    fireAll(argument) {
        const promises = []
        for (var k in this.events) {
            promises.push(this.fire(k, argument))
        }
        return Promise.all(promises)
    }
}
